module.exports = __webpack_public_path__ + "static/img/banner-bg.2b8a20c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/customerCase/banner-bg.jpg
// module id = Y82K
// module chunks = 1